import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "May 2027",
      title: "Master of Computer Science",
      place: "University of Illinois - Urbana-Champaign ",
    },
    {
      yearRange: "Mar 2025",
      title: "BS in Computer Science",
      place: "University of California, Davis",
      desc: "GPA: 3.73",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "Jun 2024 - Sep 2024",
      title: (
        <>
          Software Engineer Intern @{" "}
          <a
            href="https://citris-uc.org/"
            target="_blank"
            rel="noopener noreferrer"
            className={darkTheme ? "text-primary" : "text-danger"}
          >
            Calectra (CITRIS Grant)
          </a>
        </>
      ),
      place: "Oakland, CA",
    },

    {
      yearRange: "Jun 2024 - Sep 2024",
      title: (
        <>
          Software Engineer Intern @{" "}
          <a
            href="https://elile.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className={darkTheme ? "text-primary" : "text-danger"}
          >
            Elile AI
          </a>
        </>
      ),
      place: "Seattle, WA",
      desc: "Web Dev Team",
    },
    {
      yearRange: "Jan 2024 - present",
      title: (
        <>
          Research Assistant @{" "}
          <a
            href="https://expolab.org/"
            target="_blank"
            rel="noopener noreferrer"
            className={darkTheme ? "text-primary" : "text-danger"}
          >
            Expolab
          </a>
        </>
      ),
      place: "Davis, CA",
      desc: "Built the Charity Blockchain System with ResilientDB",
    },
    {
      yearRange: "Apr 2024 - present",
      title: (
        <>
          Machine Learning Researcher @{" "}
          <a
            href="https://faculty.engineering.ucdavis.edu/mccoy/lab-members/"
            target="_blank"
            rel="noopener noreferrer"
            className={darkTheme ? "text-primary" : "text-danger"}
          >
            Josh McCoy's Lab, UC Davis
          </a>
        </>
      ),
      place: "Davis, CA",
      desc: "Architected ML pipelines to enhance Google MT3 performance",
    },
    {
      yearRange: "Oct 2023 - Jun 2024",
      title: (
        <>
          Full Stack Developer Intern @{" "}
          <a
            href="https://order.thepantry.ucdavis.edu/"
            target="_blank"
            rel="noopener noreferrer"
            className={darkTheme ? "text-primary" : "text-danger"}
          >
            ASUCD Pantry
          </a>
        </>
      ),
      place: "Davis, CA",
      desc: "Built the Online Ordering System",
    },

    {
      yearRange: "Jun 2024 - Sep 2024",
      title: <>Research Assistant @ Sebastian Kuhnert’s Lab</>,
      place: "Davis, CA",
      desc: "Focus on autoregressive time series models",
    },
  ];

  const skills = [
    {
      name: "JavaScript/TypeScript",
      percent: 100,
    },
    {
      name: "React.js/Node.js",
      percent: 100,
    },
    {
      name: "Python/Django",
      percent: 100,
    },
    {
      name: "PostgreSQL/MongoDB",
      percent: 100,
    },
    {
      name: "AWS/Cloud Services",
      percent: 100,
    },
    {
      name: "Docker",
      percent: 100,
    },
    {
      name: "System Design",
      percent: 100,
    },
    {
      name: "Git/CI CD",
      percent: 100,
    },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* My Education */}
        <div className="mb-5">
          <h2
            className={"text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")}
          >
            My Education
          </h2>
          {educationDetails.length > 0 &&
            educationDetails.map((value, index) => (
              <div
                key={index}
                className={
                  "bg-white rounded p-4 mb-4 " +
                  (darkTheme ? "bg-dark" : "bg-white border")
                }
              >
                <p className="badge bg-primary text-2 fw-400">
                  {value.yearRange}
                </p>
                <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                  {value.title}
                </h3>
                <p className={darkTheme ? "text-primary" : "text-danger"}>
                  {value.place}
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                  {value.desc}
                </p>
              </div>
            ))}
        </div>
        {/* My Experience */}
        <div>
          <h2
            className={"text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")}
          >
            Work Experience
          </h2>
          {experienceDetails.length > 0 &&
            experienceDetails.map((value, index) => (
              <div
                key={index}
                className={
                  "bg-white rounded p-4 mb-4 " +
                  (darkTheme ? "bg-dark" : "bg-white border")
                }
              >
                <p className="badge bg-primary text-2 fw-400">
                  {value.yearRange}
                </p>
                <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                  {value.title}
                </h3>
                <p className={darkTheme ? "text-primary" : "text-danger"}>
                  {value.place}
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                  {value.desc}
                </p>
              </div>
            ))}
        </div>
        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  {/* <span className="float-end">{skill.percent}%</span> */}
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download="Weichen_Zhang_Resume.pdf"
          >
            Download Resume
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
